module.exports = __webpack_public_path__ + "static/img/bg-mp4.09c0ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-mp4.jpg
// module id = dBZ6
// module chunks = 14